/* YUNAA — éléments transverses : bandeau d'annonce, panier en tiroir,
   consentement, formulaires. Se charge après yunaa.js.
   Aucune dépendance. Chaque module s'annule si son balisage est absent. */

(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  };

  /* Le stockage local peut être refusé (navigation privée, réglages) :
     on ne laisse jamais une erreur casser la page. */
  /* Certains navigateurs (Samsung Internet en protection renforcée,
     navigateurs intégrés) effacent le stockage local d'une page à
     l'autre : le choix est donc aussi écrit dans un cookie d'un an. */
  function lire(cle) {
    var v = null;
    try { v = window.localStorage.getItem(cle); } catch (e) { /* bloqué */ }
    if (v) return v;
    var m = document.cookie.match(new RegExp("(?:^|; )" + cle.replace(/\./g, "\\.") + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function ecrire(cle, valeur) {
    try { window.localStorage.setItem(cle, valeur); } catch (e) { /* bloqué */ }
    try {
      document.cookie = cle + "=" + encodeURIComponent(valeur) +
        "; max-age=31536000; path=/; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");
    } catch (e) { /* sans effet */ }
  }

  /* ── Bandeau d'annonce ── */
  function annonce() {
    var barre = $("[data-annonce]");
    var croix = $("[data-annonce-x]");
    if (!barre || !croix) return;

    if (lire("yunaa.annonce") === "fermee") {
      barre.hidden = true;
      return;
    }

    croix.addEventListener("click", function () {
      barre.hidden = true;
      ecrire("yunaa.annonce", "fermee");
    });
  }

  /* ── Panier en tiroir ── */
  function tiroir() {
    var panneau = $("[data-drawer]");
    var ouvrir = $("[data-cart-open]");
    if (!panneau || !ouvrir) return;

    function bascule(ouvert) {
      panneau.hidden = !ouvert;
      document.body.style.overflow = ouvert ? "hidden" : "";
      if (ouvert) {
        var premier = panneau.querySelector("button, a");
        if (premier) premier.focus({ preventScroll: true });
      } else {
        ouvrir.focus();
      }
    }

    ouvrir.addEventListener("click", function () { bascule(true); });

    $$("[data-drawer-close]", panneau).forEach(function (b) {
      b.addEventListener("click", function () { bascule(false); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panneau.hidden) bascule(false);
    });
  }

  /* ── Consentement ──
     Le choix est transmis à Shopify (API Customer Privacy) : ce sont les
     pixels Shopify — Google & YouTube, Meta — qui le lisent pour savoir
     s'ils ont le droit de se déclencher. Rien ne part avant « Accepter ». */
  function transmettre(valeur) {
    var ok = valeur === "accepte";
    function envoyer() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.setTrackingConsent) return;
      cp.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, function () {});
    }
    if (window.Shopify && window.Shopify.customerPrivacy) { envoyer(); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) { if (!err) envoyer(); });
    }
  }

  function consentement() {
    var barre = $("[data-cookies]");
    if (!barre) return;

    var choix = lire("yunaa.consentement");
    /* Choix déjà connu de Shopify (cookie de consentement) : on le reprend. */
    if (!choix) {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        var c = cp && cp.currentVisitorConsent && cp.currentVisitorConsent();
        if (c && (c.marketing === "yes" || c.marketing === "no")) {
          choix = c.marketing === "yes" ? "accepte" : "refuse";
          ecrire("yunaa.consentement", choix);
        }
      } catch (e) { /* sans effet */ }
    }
    if (choix === "accepte" || choix === "refuse") {
      barre.hidden = true;
      transmettre(choix);
      return;
    }

    barre.hidden = false;

    function repondre(valeur) {
      ecrire("yunaa.consentement", valeur);
      barre.hidden = true;
      transmettre(valeur);
    }

    var ok = $("[data-cookies-accept]", barre);
    var non = $("[data-cookies-refuse]", barre);
    if (ok) ok.addEventListener("click", function () { repondre("accepte"); });
    if (non) non.addEventListener("click", function () { repondre("refuse"); });
  }

  /* ── Formulaires de démonstration ──
     Aucun envoi tant que le back-end n'est pas branché : on le dit
     franchement plutôt que de simuler un succès. */
  function formulaires() {
    var news = $("[data-newsletter]");
    if (news) {
      news.addEventListener("submit", function (e) {
        e.preventDefault();
        var msg = $("[data-newsletter-msg]");
        if (msg) {
          msg.textContent =
            "Inscription non active : le service d'envoi reste à brancher.";
        }
      });
    }

    var contact = $("[data-contact]");
    if (contact) {
      contact.addEventListener("submit", function (e) {
        e.preventDefault();
        var msg = $("[data-contact-msg]");
        if (msg) {
          msg.textContent =
            "Envoi non actif : le formulaire reste à relier à une adresse de réception.";
        }
      });
    }

    var promo = $("[data-promo]");
    if (promo) {
      promo.addEventListener("submit", function (e) { e.preventDefault(); });
    }
  }

  /* ── Année courante ── */
  function annee() {
    $$("[data-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });
  }

  function init() {
    annonce();
    tiroir();
    consentement();
    formulaires();
    annee();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
